/**
 * @generated SignedSource<<1c2d5e0a6aa3f470259e858d8f556101>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentModuleUtils_RefreshCollectionFragment$data = {
  readonly id: string;
  readonly modules: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly ordering: number | null;
        readonly " $fragmentSpreads": FragmentRefs<"ContentModuleGridItemFragment" | "ContentModuleNavigationSectionFragment">;
      };
    }>;
    readonly totalCount: number;
  };
  readonly " $fragmentType": "ContentModuleUtils_RefreshCollectionFragment";
};
export type ContentModuleUtils_RefreshCollectionFragment$key = {
  readonly " $data"?: ContentModuleUtils_RefreshCollectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentModuleUtils_RefreshCollectionFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentModuleUtils_RefreshCollectionFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentUsageNodeConnection",
      "kind": "LinkedField",
      "name": "modules",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsageNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentUsage",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "ordering",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ContentModuleGridItemFragment"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ContentModuleNavigationSectionFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Collection",
  "abstractKey": null
};
})();

(node as any).hash = "78bd5620a5aa84c9bd03ff0e29236957";

export default node;
